unit DeviceListType;

interface

uses
  WEBLib.StdCtrls,
  DeviceType;

type
  TDeviceListType = array of TDeviceType;

  procedure FillComboBoxOnDeviceTypeKey(const DeviceList: TDeviceListType; const String_DeviceTypeKey: String; var ComboBox_DeviceCodeName: TComboBox);

implementation

procedure FillComboBoxOnDeviceTypeKey(const DeviceList: TDeviceListType; const String_DeviceTypeKey: String; var ComboBox_DeviceCodeName: TComboBox);
var
  Device: TDeviceType;
  Byte_Item: Byte;
begin
  ComboBox_DeviceCodeName.Items.Clear;

  for Byte_Item := 0 to Length(DeviceList) - 1 do
    if DeviceList[Byte_Item].DeviceTypeType.TypeKey = String_DeviceTypekey then
    begin
      Device := DeviceList[Byte_Item];

      ComboBox_DeviceCodeName.Items.AddObject(Device.Code + ' | ' + Device.Name, Device);
    end;
end;

end.
